/* eslint-disable react/prop-types */
import React from "react";
import CompoundModal from "../organisms/compoundModal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Eye, MoreHorizontal, Trash } from "lucide-react";
import { Separator } from "../ui/separator";
import ConfirmDelete from "../organisms/confirmDelete";
import { useRouter } from "next/router";
import { useDeleteSession } from "@/hooks/ai-mode/useSessions";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setData, setPreviewOpen } from "@/store/assistance";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { useAssistance } from "@/context/assistanceProvider";

export default function SessionItem({ session }) {
  const router = useRouter();

  const { mutate: deleteSession, isPending: isDeleting } = useDeleteSession();
  const { isPending } = useAssistance();
  const dispatch = useDispatch();

  const currentSessionId = router.query.sessionId;

  const handleDeleteSession = (sessionId) => {
    if (isPending) {
      toast("Please wait for the current response to finish.");
      return;
    }
    deleteSession(sessionId);

    dispatch(setPreviewOpen(false));

    router.push("/ai-mode", undefined, { shallow: true });
  };

  const handleSessionClick = (session) => {
    if (session.id === currentSessionId) return;
    if (isPending) {
      toast("Please wait for the current response to finish.");
      return;
    }
    dispatch(setPreviewOpen(false));
    dispatch(setData(null));
    router.push(`/ai-mode?sessionId=${session.id}`, undefined, {
      shallow: true,
    });
  };

  return (
    <HoverCard>
      <HoverCardTrigger>
        <div
          onClick={() => handleSessionClick(session)}
          className={`flex items-center justify-between gap-4 px-4 py-4 hover:bg-gray-200   hover:text-accent-foreground  dark:hover:bg-accent  box-border transition-all duration-300 rounded-xl cursor-pointer hover-parent  ${
            session.id === currentSessionId
              ? "bg-gray-200/70 dark:bg-accent"
              : ""
          }`}
        >
          <p
          
            className="text-[1.4rem] h-6 truncate w-full"
          >
            {session.workflow?.workflow_name || session.title}
          </p>
          <CompoundModal>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <MoreHorizontal
                  className="size-6 hover-child"
                  style={{
                    minWidth: 12,
                    width: 12,
                    minHeight: 12,
                    height: 12,
                  }}
                />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="rounded-xl z-[9999] dark:border-input">
                <DropdownMenuItem
                  onClick={() => handleSessionClick(session)}
                  className="text-[1.3rem] cursor-pointer px-7 py-3 flex items-center gap-4"
                >
                  <Eye
                    style={{
                      width: 12,
                      height: 12,
                    }}
                  />
                  Open
                </DropdownMenuItem>
                <Separator />
                <CompoundModal.Open name={"delete-session"}>
                  <DropdownMenuItem
                    className={`text-[1.3rem] text-red-400   cursor-pointer flex items-center gap-4 px-7 py-3 ${
                      isDeleting ? "bg-muted" : ""
                    } `}
                  >
                    <Trash
                      className="text-red-400"
                      style={{
                        width: 12,
                        height: 12,
                      }}
                    />
                    <span className="hover:text-red-500">Remove</span>
                  </DropdownMenuItem>
                </CompoundModal.Open>
              </DropdownMenuContent>
            </DropdownMenu>
            <CompoundModal.Window name={"delete-session"}>
              <ConfirmDelete
                resourceName={"session"}
                onConfirm={() => handleDeleteSession(session.id)}
              />
            </CompoundModal.Window>
          </CompoundModal>
        </div>
      </HoverCardTrigger>

      <HoverCardContent align="start" className="w-full dark:border-input">
        <p
          onClick={() => handleSessionClick(session)}
          className="text-[1.3rem] text-foreground cursor-pointer  leading-7  w-full"
        >
          {session.workflow?.workflow_name || session.title}
        </p>
        <span className="mt-4  inline-block text-foreground/70 text-[1.2rem]  w-full">
          {format(session.created_at, "dd MMM y hh:mm a")}
        </span>
      </HoverCardContent>
    </HoverCard>
  );
}
